import { render, staticRenderFns } from "./PostEditImmoObject1400.vue?vue&type=template&id=0a796098&"
import script from "./PostEditImmoObject1400.vue?vue&type=script&lang=js&"
export * from "./PostEditImmoObject1400.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports